import { createSelector } from 'reselect'

const calendarioReducerSelector = state => state.turneroReducer.getIn(["data"]).toJS()
export const calendarioSelector = createSelector(
    calendarioReducerSelector, (dataField) => {    
    return dataField.calendario
  }
)

const calendariosTurneroReducerSelector = state => state.configuracionesReducer.getIn(["data"]).toJS()
export const calendariosTurneroSelector = createSelector(
    calendariosTurneroReducerSelector, (dataField) => {  
    return dataField.calendariosTurnero
  }
)